import { LocationQuery } from 'vue-router';
import { cacheFirstConfig, http } from '../../helpers/http.helper';
import { ApiResource } from '../../models/api-resource.interface';
import { DriversLicense } from './drivers-license.interface';

export class DriversLicenseService {
   async getDriversLicenses(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<DriversLicense>>>(`/nxt-drivers-licenses`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
